module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.noticeTop.length > 0) ? _c('marquee', {
    staticClass: "notice",
    attrs: {
      "scrollamount": "5"
    }
  }, _vm._l((_vm.noticeTop), function(item, index) {
    return _c('span', {
      key: index
    }, [_vm._v("\n      " + _vm._s('● ' + item) + "\n    ")])
  })) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7cfc2864!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/notice.vue
// module id = 1195
// module chunks = 67